import { HeartHandshake, Anchor, BookOpen, PenLine, Compass, Sunset } from "lucide-react";
import { FadeUp, SectionHeading } from "../components/motion";

const CLASSES = [
  {
    title: "Caring for the Caregiver",
    body: "Explore compassion fatigue, healthy boundaries, and practical ways to make room for your own renewal.",
    icon: HeartHandshake,
  },
  {
    title: "Finding Stillness at Sea",
    body: "Discover simple practices for prayer, quiet reflection, and carrying moments of stillness into everyday life.",
    icon: Anchor,
  },
  {
    title: "Your Story Matters: Begin Your Book",
    body: "Explore your message, identify your audience, and begin shaping an outline. No writing experience is required.",
    icon: BookOpen,
  },
  {
    title: "Legacy and Spiritual Journaling",
    body: "Use guided writing prompts to reflect on your journey, values, and the stories you hope to preserve.",
    icon: PenLine,
  },
  {
    title: "Exploring Chaplaincy",
    body: "An introduction to chaplaincy roles, service settings, and educational pathways for those considering this calling.",
    icon: Compass,
  },
  {
    title: "Sunset Gratitude Circle",
    body: "An optional gathering to reflect on the day, share gratitude, and connect with fellow participants.",
    icon: Sunset,
  },
];

export default function Classes() {
  return (
    <section id="classes" data-testid="section-classes" className="bg-cream py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          tone="light-bg"
          eyebrow="Planned Classes & Reflection Experiences"
          titleLines={["Planned Classes &", "Reflection Experiences"]}
          intro="Explore opportunities for personal renewal, spiritual growth, creative expression, and connection. Our inaugural retreat’s class selection is being developed, with a gentle schedule that leaves ample time for rest and enjoyment."
        />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="classes-grid">
          {CLASSES.map((c, i) => (
            <FadeUp key={c.title} delay={0.06 * i} className="h-full">
              <article
                data-testid={"class-card-" + (i + 1)}
                className="group flex h-full flex-col border border-navy/12 bg-parchment p-7 transition-all duration-500 hover:-translate-y-1 hover:border-gold/60 hover:shadow-[0_18px_45px_rgba(11,25,44,0.08)]"
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[11px] tracking-[0.3em] text-gold">{String(i + 1).padStart(2, "0")}</span>
                  <c.icon size={22} strokeWidth={1.25} className="text-navy/60 transition-colors duration-500 group-hover:text-gold" aria-hidden="true" />
                </div>
                <h3 className="mt-5 font-serif text-2xl font-normal leading-snug text-navy">{c.title}</h3>
                <p className="mt-3 text-sm font-light leading-relaxed text-navy/70">{c.body}</p>
              </article>
            </FadeUp>
          ))}
        </div>
        <FadeUp delay={0.15}>
          <div className="mt-10 border-l-2 border-gold/60 pl-5" data-testid="classes-note">
            <p className="max-w-3xl text-sm leading-relaxed text-navy/70">
              These are proposed offerings. Final classes, instructors, times, and onboard
              locations will be announced when confirmed. Participation is optional.
            </p>
            <p className="mt-3 max-w-3xl text-xs leading-relaxed text-navy/50">
              Consistent with our FAQ: no continuing education credit, certification, therapy, or
              employment guarantees are currently offered.
            </p>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
